import styled from 'styled-components'

import { Colors, mediaQueries } from '@fourthwall/components'

export const Container = styled.a`
  width: 100%;
  padding: 16px;
  background: ${Colors.GS200};

  display: grid;
  gap: 16px;

  margin-bottom: 16px;

  text-align: initial;

  ${mediaQueries.tablet} {
    grid-template-columns: auto 1fr;
    gap: 24px;

    align-items: center;
  }

  padding: 8px;
  gap: 20px;

  ${mediaQueries.tablet} {
    gap: 20px;
  }
`

export const Thumbnail = styled.div`
  position: relative;
`

export const ThumbnailImage = styled.img`
  display: block;
  width: 100%;
  height: 40px;

  aspect-ratio: 560 / 315;
  object-fit: cover;

  ${mediaQueries.tablet} {
    max-height: 120px;
  }
`
